import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../../common'
import { i18nKeyPrefix } from '../../../../i18n'

import { FilterControl } from '../common'
import IFullSearchProps from '../types'
import FilterForm from './FilterForm'

const PRE = `${i18nKeyPrefix}-FILTERS-AVAILABILITY`

export default function AvailabilityFilter(props: IFullSearchProps) {
  const {
    filters,
    displayForm,
    palette,
    onChangeFilters,
    onRequestCloseForm,
    onRequestDisplayForm,
  } = props
  const isActive = filters.hasAvailability ? filters.hasAvailability : false
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <div data-pendo="availabilityFilterButton">
      <FilterControl
        isActive={isActive}
        label={t(`${PRE}-LABEL`)}
        displayForm={displayForm}
        palette={palette}
        onRequestCloseForm={onRequestCloseForm}
        onRequestDisplayForm={onRequestDisplayForm}
        filterForm={
          <FilterForm
            filters={filters}
            onChangeFilters={onChangeFilters}
            onRequestCloseForm={onRequestCloseForm}
          />
        }
      />
    </div>
  )
}
